import gql from 'graphql-tag';

export enum ClustersSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  BILLING_CANCELLATION_REVOKED = 'BILLING_CANCELLATION_REVOKED',
  BILLING_CANCELLED = 'BILLING_CANCELLED',
  BILLING_CANCELLING = 'BILLING_CANCELLING',
  PAYMENT_EXPIRED = 'PAYMENT_EXPIRED',
  PAYMENT_EXPIRING = 'PAYMENT_EXPIRING',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  TRIAL_PERIOD = 'TRIAL_PERIOD',
  TRIAL_PERIOD_EXPIRED = 'TRIAL_PERIOD_EXPIRED',
  TRIAL_PERIOD_CANCELLED = 'TRIAL_PERIOD_CANCELLED',
}

export enum ClustersLicensesSubscriptionStatus {
  INSUFFICIENT_LICENCES = 'INSUFFICIENT_LICENCES',
}

export enum BillingPrettyStatus {
  ACTIVE = 'Active',
  BILLING_CANCELLATION_REVOKED = 'Billing cancellation revoked',
  BILLING_CANCELLED = 'Billing cancelled',
  BILLING_CANCELLING = 'Billing cancelling',
  PAYMENT_EXPIRED = 'Payment expired',
  PAYMENT_EXPIRING = 'Payment expiring',
  PAYMENT_FAILED = 'Payment failed',
  TRIAL_PERIOD = 'Trial in progress',
  TRIAL_PERIOD_EXPIRED = 'Trial expired',
  TRIAL_PERIOD_CANCELLED = 'Trial cancelled',
  PAID_SUBSCRIPTION_EXPIRED = 'Expired',
}

export enum BillingStatusBadgeColor {
  ACTIVE = 'green',
  BILLING_CANCELLATION_REVOKED = 'yellow',
  BILLING_CANCELLED = 'red',
  BILLING_CANCELLING = 'yellow',
  PAYMENT_EXPIRED = 'yellow',
  PAYMENT_EXPIRING = 'yellow',
  PAYMENT_FAILED = 'yellow',
  TRIAL_PERIOD = 'green',
  TRIAL_PERIOD_EXPIRED = 'red',
  TRIAL_PERIOD_CANCELLED = 'red',
  PAID_SUBSCRIPTION_EXPIRED = 'red',
}

export type SubscriptionStatusInput = {
  subscriptions: BillingSubscriptionsResponse[];
  customerId: string;
  customerName?: string;
};

export const BillingSubscriptionsFragment = gql`
  fragment BillingSubscriptionsFragment on BillingSubscription {
    cloudProvider
    clustersSubscriptionStatus
    clustersLicencesSubscriptionStatus
    expiryDate
  }
`;

export interface BillingSubscriptionsResponse {
  __typename?: string;
  clustersSubscriptionStatus: ClustersSubscriptionStatus;
  clustersLicencesSubscriptionStatus?: ClustersLicensesSubscriptionStatus;
  cloudProvider?: string;
  expiryDate?: string;
}

export const ClusterSubscriptionStatuses = [
  ClustersSubscriptionStatus.ACTIVE,
  ClustersSubscriptionStatus.BILLING_CANCELLATION_REVOKED,
  ClustersSubscriptionStatus.BILLING_CANCELLED,
  ClustersSubscriptionStatus.BILLING_CANCELLING,
  ClustersSubscriptionStatus.PAYMENT_EXPIRED,
  ClustersSubscriptionStatus.PAYMENT_EXPIRING,
  ClustersSubscriptionStatus.PAYMENT_FAILED,
  ClustersSubscriptionStatus.TRIAL_PERIOD,
  ClustersSubscriptionStatus.TRIAL_PERIOD_EXPIRED,
  ClustersSubscriptionStatus.TRIAL_PERIOD_CANCELLED,
];
